export default function ProfilePage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-2xl font-bold text-gray-800 mb-10">プロフィール</h1>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-16 h-16 rounded-full overflow-hidden border border-gray-100 shadow-sm">
            <img src="/images/profile.png" alt="プロフィール画像" className="w-full h-full object-cover" />
          </div>
          <div>
            <h2 className="font-bold text-gray-800 text-lg">臨床ナースラボ 管理者</h2>
            <p className="text-green-800 text-sm">現役看護師</p>
          </div>
        </div>
        <div className="text-gray-600 text-sm leading-relaxed space-y-4">
          <p>
            「手を動かす技術」だけじゃなく、「人に伝わる言葉」と「自分を動かす知識」まで——看護師として働く上でほんとうに役立つことを、ひとつずつ。
          </p>
          <p>
            現役看護師として日々の臨床で感じてきた「これ、もっと早く知りたかった」をもとに、手技・コミュニケーション・思考の土台になる知識を発信しています。
          </p>
          <p>
            技術の手順と根拠、アサーションや動機づけ面接などのコミュニケーションスキル、そして行動経済学など、働く上で視野が広がる知識も扱っていく予定です。
          </p>
          <p>
            同じ現場で働く看護師のみなさんの、日々の学習や業務の中で少しでもお役に立てたら嬉しいです。
          </p>
        </div>
      </div>
    </div>
  );
}
